<script lang="ts" setup>
import DefaultLayout from '@consumer/layouts/DefaultLayout.vue'
import SupportLayout from '@consumer/layouts/SupportLayout.vue'
import CategoryPage from '@consumer/modules/support/CategoryPage.vue'
import type { Gift, PurchasedOrder } from '@consumer/types/serializers'
import type { SupportArticle, SupportCategory } from '@consumer/types/SupportArticle'

defineOptions({
  layout: [DefaultLayout, SupportLayout],
})

const props = defineProps<{
  currentCategory: SupportCategory
  supportArticles: SupportArticle[]
  order?: PurchasedOrder
  gift?: Gift
}>()
</script>

<template>
  <Head>
    <title>{{ currentCategory.label }} | Giftly Help Center</title>
  </Head>

  <CategoryPage v-bind="props"/>
</template>
